/* @flow */
import React, { Component } from 'react';
import debounce from 'lodash.debounce';
import { copyProperties } from '../../utils';

export default function<P>(WrappedComponent: React.ComponentType<P>) {
  const component = WrappedComponent;

  class WindowWidth extends Component<
    { componentRef?: any },
    { dimensions: { width: number, height: number } }
  > {
    constructor(props) {
      super(props);
      this.state = {
        dimensions: {
          width: window.innerWidth,
          height: window.innerHeight,
        },
      };
    }

    componentDidMount() {
      window.addEventListener('resize', this._onResize);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this._onResize);
    }

    _onResize = debounce(() => {
      this.setState({
        dimensions: {
          width: window.innerWidth,
          height: window.innerHeight,
        },
      });
    }, 50);

    render() {
      const { componentRef, ...props } = this.props;
      const { dimensions } = this.state;
      return <WrappedComponent ref={componentRef} windowDimensions={dimensions} {...props} />;
    }
  }

  // Class inheritance uses Object.create and because of __proto__ issues
  // with IE <10 any static properties of the superclass aren't inherited and
  // so need to be manually populated.
  // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-
  copyProperties(component, WindowWidth);

  return WindowWidth;
}



// WEBPACK FOOTER //
// ./src/ui/components/withWindowDimensions.js